import React, { useState } from 'react'
import { Button, ListSubheader, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import { ExpandIcon } from './ExpandIcon'
import { spacing } from '../styling'

type IAccordionMenu = {
  subtitle: string
  expanded?: boolean
  defaultExpanded?: boolean
  gutters?: boolean
  elevation?: number
  square?: boolean
  disabled?: boolean
  onClear?: () => void
  onClick?: (expanded: boolean) => void
  action?: React.ReactNode
  children?: React.ReactNode
}

export const AccordionMenuItem: React.FC<IAccordionMenu> = ({
  expanded,
  defaultExpanded,
  subtitle,
  gutters,
  elevation = 0,
  square,
  disabled,
  onClear,
  onClick,
  action,
  children,
}) => {
  const [open, setOpen] = useState<boolean>(!!defaultExpanded)
  const clickHandler = () => {
    onClick && onClick(!open)
    setOpen(!open)
  }

  expanded = expanded === undefined ? open : expanded

  return (
    <Accordion
      square={square}
      elevation={elevation}
      expanded={expanded}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
    >
      <AccordionSummary
        sx={{
          marginTop: `${spacing.xxs}px`,
          marginBottom: `${spacing.xxs}px`,
          marginLeft: gutters ? `${spacing.md}px` : undefined,
          marginRight: gutters ? `${spacing.md}px` : undefined,
          '& .MuiIconButton-root': {
            marginTop: `${-spacing.xxs}px`,
            marginBottom: `${-spacing.xxs}px`,
          },
          '& .MuiButton-root:first-of-type': {
            width: '100%',
            textAlign: 'left',
            display: 'block',
            padding: 0,
            margin: 0,
          },
          '& .MuiButton-root + .MuiButton-root': {
            marginRight: `${spacing.md}px`,
          },
        }}
      >
        <Button onClick={clickHandler}>
          <ListSubheader disableGutters>
            {subtitle}
            <ExpandIcon open={expanded} />
          </ListSubheader>
        </Button>
        {onClear && (
          <Button
            size="small"
            color="primary"
            onClick={event => {
              event.stopPropagation()
              onClear()
            }}
          >
            Clear
          </Button>
        )}
        {action && action}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
